export enum Default {
  SUBSCRIPTION_PLAN = "standard",
  PAYPAL_BUTTON_COLOUR = "white",
}
